import axios from '@/libs/api.request'
import {getToken} from '@/libs/util'
import config from '@/config'

// const projectBaseUrl = 'http://127.0.0.1:8002/api/1.0/project/'
// 持续发布基础URL
const baseDeployUrl = config.baseDeployUrl
const projectBaseUrl = baseDeployUrl + '/api/1.0/project/'

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

export const getList = (params) => {
  return axios.request({
    url: projectBaseUrl + 'list',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getNameList = () => {
  return axios.request({
    url: projectBaseUrl + 'list/name',
    headers: baseHeaders,
    method: 'get'
  })
}

export const fetchProjectLogs = (id) => {
  return axios.request({
    url: projectBaseUrl + id + '/history',
    headers: baseHeaders,
    method: 'get'
  })
}

export const fetchDeploymentData = (id, scenes) => {
  return axios.request({
    url: projectBaseUrl + id + '/deployment/' + scenes,
    headers: baseHeaders,
    method: 'get'
  })
}

export const getProjectDetail = (params) => {
  return axios.request({
    url: projectBaseUrl + params.id,
    headers: baseHeaders,
    method: 'get'
  })
}

export const getUserProjectsList = (params) => {
  return axios.request({
    url: projectBaseUrl + 'user/projects',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const fetchProjectCommitsData = (params) => {
  return axios.request({
    url: projectBaseUrl + params.project + '/commits',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const fetchMasterCommitsList = (value) => {
  return axios.request({
    url: projectBaseUrl + value + '/commits/list',
    headers: baseHeaders,
    method: 'get'
  })
}

export const fetchProjectInfoData = (value) => {
  return axios.request({
    url: projectBaseUrl + value + '/info',
    headers: baseHeaders,
    method: 'get'
  })
}

export const ProjectBaseInfoSubmit = (id, data) => {
  return axios.request({
    url: projectBaseUrl + id,
    headers: baseHeaders,
    data: data,
    method: 'put'
  })
}

export const fetchProjectCodeData = (value) => {
  return axios.request({
    url: projectBaseUrl + value + '/code',
    headers: baseHeaders,
    method: 'get'
  })
}

export const editProjectCodeData = (value, data) => {
  return axios.request({
    url: projectBaseUrl + value + '/code',
    headers: baseHeaders,
    data: data,
    method: 'put'
  })
}

// 项目部署信息修改提交
export const ProjectDeploymentSubmit = (id, data, scenes) => {
  return axios.request({
    url: projectBaseUrl + id + '/deployment/' + scenes,
    headers: baseHeaders,
    data: data,
    method: 'put'
  })
}

// 取到project dashboard
export const getProjectDashboard = (value) => {
  let params = {
    size: value
  }
  return axios.request({
    url: projectBaseUrl + 'dashboard/count',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

// 取到project 发布趋势数据
export const getDeployTrend = (params) => {
  return axios.request({
    url: projectBaseUrl + 'dashboard/trend',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getMemberSelList = (params) => {
  return axios.request({
    url: projectBaseUrl + 'member_project_list',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}
